import(/* webpackMode: "eager", webpackExports: ["ProductPageLoadingSkeleton"] */ "/home/runner/_work/holibob/holibob/booking-web/app/[locale]/product/[input]/ProductPageLoadingSkeleton.tsx");
